<template>
    <main>
         <div>
            <div class="card text-center" style="padding: 10px 5% 10px; min-height:200px" v-if="tab[0].visible">
                <div class="J-card-header">
                    <label style="font-size:20px; font-weight:bold">Referidos para negocios</label>
                </div>
                <div class="card-body" style="margin:auto; display: contents;">
                    <div class="J-referrals-container J-container-list">
                        <a @click="create()" v-if="!referred.is_link" href="javascript:void(0)">crear link</a>
                        <span  v-else>
                            link de referido 
                            <a @click="copyLink(referred.link)" href="javascript:void(0)">{{referred.link}}</a>
                        </span>
                        <br>
                        <br>
                        <div v-if="referred.list.length<=0">
                            <label for="">
                                No tienes referidos de negocios. 
                            </label>
                            <p>
                                <b>
                                    ¡Importante!
                                </b>
                                El referido de negocio funciona cuando tu logras que el link obtenido lo utilicen aquellos negocios para registrarse.
                                El beneficio que tendrás sera el siguiente: Podras obtener cupones cada ves que el negocio crea cupones de descuento,
                                recuerda solo sera 5 cupones distintos por cada negocio.
                            </p>
                        </div>
                        <v-flex v-else xs12  v-for="item in referred.list" :key="item._id">
                            <v-card color="" class="dark--text J-btn" @click="viewCoupons(item._id_company)">
                                <v-layout class="J-layaut">
                                    <v-flex xs3>
                                    <v-img
                                        :src="item._id_company.image_company.length <= 0?'https://cdn.vuetifyjs.com/images/cards/foster.jpg' : item.image_company[0].link"
                                        height="125px"
                                    ></v-img>
                                    </v-flex>
                                    <v-flex xs9>
                                    <v-card-title primary-title>
                                        <div>
                                        <div class="headline J-headline">{{item._id_company.name.toUpperCase()}}</div>
                                        </div>
                                    </v-card-title>
                                     <div>
                                        <div class="J-float-right J-float-right-10 J-count-number" title="Restante">{{item.remaining}}</div>
                                    </div>
                                    </v-flex>
                                </v-layout>
                            </v-card>
                            <br>
                        </v-flex>
                    </div>
                </div>
            </div>
            <div class="card text-center" style="padding: 10px 5% 10px; min-height:200px" v-else>
                <div class="J-card-header">
                    <label style="font-size:20px; font-weight:bold">Lista de cupones {{company.name}}</label>
                </div>
                <div class="card-body" style="margin:auto; display: contents;">
                    <div class="J-referrals-container J-container-list">
                        <component-coupons-list :dataCoupons="dataCoupons" :company="company"/>
                    </div>
                </div>
            </div>
         </div>
    </main>
</template>
<script>
    const alertify = require('alertifyjs')
    alertify.set('notifier','position', 'top-center');
    import { EventBus } from '@/helpers/eventbus/event-bus'
    import {ReferredService} from '@/services'
    
    export default {
        data(){
            return{
                count:0,
                countClass:"active30",
                flareExample:null,
                valFinish:0,
                tween:null,
                dataCoupons:[],
                referred:{
                    is_link:false,
                    link:"",
                    id:"",
                    list:[]
                },
                company:null,
                isScanning:false,
                myCroppa: {},
                tab:[
                    {id:1,title:'Crear',visible:true,checked:false},
                    {id:2,title:'Cupones',visible:false,checked:false}
                    //{id:3, title:'Sedes',visible:false,checked:false}
                ],

            }
        },
        mounted(){
            this.list()
        },
        components:{
            "component-coupons-list":()=>import("@/components/partials/CuponesList.partials"),
        },
        methods:{
            viewCoupons(company){
                console.log(company)
                this.company=company
                this.listCoupons(company._id)
                this.isTabActive(1)
            },
            
            isTabActive:function(index){
                for (let i = 0; i < this.tab.length; i++) {
                this.tab[i].visible=false;                
                }
                this.tab[index].visible=true;     
            },
            recuvaUrl(blobUrl){
                _this.$emit('close')
            },
            copyLink:function(data){
                // var URLdomain = window.location.origin;
                // this.copyTextClipBoard(`${URLdomain}?referred=${data}`);

                this.copyTextClipBoard(data);
            },
            copyTextClipBoard:function(text){
                if(!navigator.clipboard){
                    this.fallbackCopyTextToClipboard(text);
                    return;
                }
                navigator.clipboard.writeText(text)
                .then(()=>{
                    alertify.success('copiado');
                })
                .catch(err=>{
                    console.error('Could not copy text:',err)
                })
            },
            create(){
                ReferredService.create().then((res)=>{
                    alertify.success('Link de referido creado')
                    this.referred.is_link=true;
                    this.referred.link=res.data.data.link;
                })
                .catch((err)=>{
                    alertify.error('Link de referido no creado')

                })
            },
            list(){
                ReferredService.list().then((res)=>{
                    this.referred.is_link=true;
                    this.referred.id=res.data.data._id;
                    this.referred.list=res.data.data.referred_list;

                    this.referred.link= `${window.location.origin}/?referred=${this.referred.id}`;

                })
            },
            listCoupons(id){
                ReferredService.listCoupons({id_company:id,referred:this.referred.id})
                .then(res=>{
                    var {data}=res.data;
                    if(data) this.dataCoupons=data.reverse();
                })
                .catch(err=>{
                    
                });
            },
        }

    }
</script>